import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { shallowEqual } from 'react-redux';
import { useSelector } from '../../../../reduxToolkit/typedRedux';
import { createDisplayLink } from '../../../../services/helper';

const MBWHeader = () => {
  const [menuBar, setMenuBar] = useState<any>();
  const [bubbleHeight, setBubbleHeight] = useState(0);

  const currentPageData = useSelector((state) => state.common.pagebuilder.currentpagedata);
  const isMobilePreview = useSelector((state) => state.common.isMobilePreview);

  const bubbleRef = useRef<HTMLDivElement>(null);

  const {
    query: { pagename },
  } = useRouter();

  const { event, user, templateEditMode, pagedata } = useSelector(
    ({ common: { event, user, templateEditMode, pagedata } }) => ({
      event,
      user,
      templateEditMode,
      pagedata,
    }),
    shallowEqual
  );
  function onResize() {
    if (!bubbleRef.current) return;
    setBubbleHeight(bubbleRef.current.clientHeight);
  }

  useEffect(() => {
    onResize();
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [bubbleRef.current, menuBar]);

  useEffect(() => {
    if (user && user.role !== 'PARTICIPANT_ANONYM') setMenuBar(currentPageData?.template?.menuBar);
    else setMenuBar(pagedata?.template?.menuBar);
  }, [currentPageData?.template?.menuBar, pagedata?.template?.menuBar, user]);

  if (!menuBar?.active) return <></>;

  return (
    <header className="z-30 flex justify-center lg:sticky shadow-lg top-0 min-h-[6rem]">
      <div className="w-4/5 max-w-[1333px] h-full py-4 flex flex-col-reverse sm:flex-row justify-between items-center relative flex-wrap sm:flex-nowrap sm:gap-8">
        <div className="flex flex-col space-y-2 h-full sm:w-full">
          <p className="upper-text">{menuBar?.upperText}</p>
          <div
            className="lower-text"
            dangerouslySetInnerHTML={{ __html: menuBar?.title ?? event?.name }}
            style={{ marginTop: `${menuBar?.marginBetweenTitles}px` }}
          />
          {menuBar?.bubbleText && (
            <div ref={bubbleRef} className={`bubble absolute px-4 rounded-full min-h-12 py-1 flex items-center gap-2`}>
              {menuBar?.bubbleImage && (
                <>
                  <img src={createDisplayLink(menuBar?.bubbleImage)} alt="bubble-image" className="h-8" />
                  <div
                    className="w-[1px] bg-slate-800"
                    style={{
                      backgroundColor: event?.organization?.customUpperTextColor ?? event?.template.mainButtonTextColor,
                      height: bubbleHeight - 20,
                    }}></div>
                </>
              )}
              <p>{menuBar?.bubbleText}</p>
            </div>
          )}
        </div>
        <div className="flex flex-row">
          {event?.template.secondaryLogo && (
            <img src={createDisplayLink(event.template.secondaryLogo)} className="mr-4 mb-6 h-32 sm:mb-0" alt="vbw-secondary-logo" />
          )}
          <img
            src={event?.template.logo ? createDisplayLink(event.template.logo) : event?.organization?.defaultEventLogo ?? '/baymevbm-vbw/vbw-logo.png'}
            style={{ minWidth: '8rem' }}
            className={`${event?.template.logo ? 'h-32' : 'w-32 h-32'} mb-6 sm:mb-0 object-contain`}
            alt="vbw-logo"
          />
        </div>
      </div>
      <style jsx>
        {`
          header {
            color: ${event?.template.complementButtonTextColor};
            background-color: ${event?.template.complementColor};
            .bubble {
              background-color: ${event?.template.mainColor};
              color: ${event?.template?.mainButtonTextColor};
              bottom: ${menuBar?.bubbleText ? `-${bubbleHeight / 2}px` : '27px'};
              left: -1rem;
              font-size: ${menuBar?.bubbleFontSize * (isMobilePreview ? 1.2 : 1.5)}px;
              font-family: ${menuBar.fontFamily ?? event?.template.customFont};
            }
            .upper-text {
              font-size: ${menuBar?.fontSize * (isMobilePreview ? 1.2 : 1.5)}px;
              font-family: ${menuBar.fontFamily ?? event?.template.customFont};
              ${event?.organization?.customUpperTextColor ? `color: ${event?.organization?.customUpperTextColor};` : ''}
            }
            .lower-text {
              ${menuBar?.bubbleText ? `margin-bottom:${bubbleHeight / 2}px;` : ''}
              font-size: ${menuBar?.fontSize * (isMobilePreview ? 2.8 : 3.5)}px;
              ${event?.organization?.name?.includes('bayme') ? `font-family: GeogrotesqueMedium;` : ''}
            }
          }
          @media (max-width: 768px) {
            .upper-text {
              font-size: ${menuBar?.fontSize * 1.2}px;
            }
            .lower-text {
              font-size: ${menuBar?.fontSize * 2.8}px;
            }
            .bubble {
              font-size: ${menuBar?.bubbleFontSize * 1.2}px;
            }
          }
        `}
      </style>
    </header>
  );
};
export default MBWHeader;
